import assetsConfig from '@meitu/wasm-lib/assetsConfig.json';

export const AR_RES_ID = 'ar_res';
export const AR_RES_PATH = assetsConfig.text_ar_res;
export const AR_PUBLIC_PARAMS = assetsConfig.text_hbpArPublicParams;

// 基础文字，宽度不固定，会根据ar绘制自适应
export const HBP_TEXT_RES_ID = 'hbp';
export const HBP_TEXT_PATH = assetsConfig.text_effect_hbp;
export const HBP_TEXT_PLIST = `${HBP_TEXT_RES_ID}/ar/configuration.plist`;

// 变形文字
export const SHAPE_TEXT_RES_ID = 'textpatheffect';
export const SHAPE_TEXT_PATH = assetsConfig.text_effect_textpatheffect;
